import axios from "axios";

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class GenericService {
  async warehouses(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.get(
        API_URL + `/Warehouses?Limit=${payload.limit}`,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async clients(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.post(
        API_URL + `/Clients/SearchAndSort`,
        payload,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async users(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.post(
        API_URL + `/Users/SearchAndSort`,
        payload,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default new GenericService();
